import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {interval, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {CookieService} from '@app/modules/shared/services/cookie.service';
import {ClassroomState, ClassroomStateModel} from '@app/state/classroom-state.service';
import {Store} from '@ngxs/store';
import {HttpClient} from '@angular/common/http';
import {User} from '@app/models/vcr-entity/user';
import {VcrEntity} from '@app/models/vcr-entity/entity';
import {LocalUser, LocalUserAction} from '@app/state/local-user.state';

@Component({
  selector: 'app-diagnostic-enter-page',
  templateUrl: './diagnostics-login-page.component.html',
  styleUrls: ['./diagnostics-login-page.component.css']
})
export class DiagnosticsLoginPageComponent implements OnInit {
  public room: ClassroomStateModel;
  public guestName: string;
  public smartsuppUsername: string;

  constructor(
    private cookieService: CookieService,
    private router: Router,
    private store: Store,
    private http: HttpClient
  ) {
    this.listenStoreChanges();
  }

  private listenStoreChanges(): void {
    this.store.select(ClassroomState).subscribe((room: ClassroomStateModel) => {
      this.room = room;
    });
  }

  ngOnInit(): void {
    const pauseInterval = new Subject();
    interval(500).pipe(takeUntil(pauseInterval)).subscribe(value => {
      const visitorId = this.cookieService.get('ssupp.vid');
      if (visitorId) {
        this.smartsuppUsername = 'Visitor-' + visitorId;
        pauseInterval.next(0);
      }
    });
  }

  creatNewGuest(event: any) {
    event.preventDefault();

    this.http.post<User>(`${this.room.vcrURL}/diagnosticsLogin/${this.guestName}`, null).subscribe((user: User): void => {
      if (user) {
        const localUser: User = VcrEntity.createEntity(User, user);
        this.store.dispatch(new LocalUserAction.SetLocalUser(new LocalUser(localUser)));
      }

      if (this.room.roomNum === 0) {
        this.router.navigateByUrl(`/diagnostics`).then();
      } else {
        this.router.navigateByUrl(`/${this.room.roomNum}/diagnostics`).then();
      }
    });
  }
}
